// ACTA_AGENT_LLM_PLANNER_SCHEMA_V4
function jsType(def){if(["integer","number","boolean","array","object"].includes(def.type))return def.type;if(def.type==="file")return "object";return "string";}
function fieldSchema(def){const s={type:jsType(def),description:def.description||def.name};if(def.type==="enum"&&def.values?.length)s.enum=[...def.values];if(typeof def.minimum==="number")s.minimum=def.minimum;if(typeof def.maximum==="number")s.maximum=def.maximum;return s;}
function paramsSchema(contract){const properties={};for(const def of contract.fields||[])properties[def.name]=fieldSchema(def);return {type:"object",properties,additionalProperties:false};}
function branch(contract){return {type:"object",properties:{id:{type:"string",const:contract.id},params:paramsSchema(contract)},required:["id","params"],additionalProperties:false};}
export function buildAgentPlannerSchema(contracts=[]){const ready=contracts.filter(x=>x.plannerReady);if(!ready.length)throw new Error("Aucune action Agent disponible pour le planner.");return {name:"acta_agent_plan",strict:true,schema:{type:"object",properties:{actions:{type:"array",minItems:1,maxItems:10,items:{oneOf:ready.map(branch)}}},required:["actions"],additionalProperties:false}};}
export function buildAgentPlannerSystemPrompt(contracts=[]){
  const tools=contracts.filter(x=>x.plannerReady).map(c=>`- ${c.id}: ${c.label} | paramètres: ${(c.fields||[]).map(f=>f.name).join(", ")}`).join("\n");
  return ["Tu es le planner de l'application métier Acta.","Tu transformes uniquement la demande en plan structuré.","Tu ne dois jamais exécuter une action métier toi-même.","Tu ne dois jamais inventer un identifiant, un contact, une date, une heure, un montant ou une information absente.","Si une information n'est pas fournie, omets le paramètre correspondant.","Pour un contact, conserve exactement le nom, la société, l'email ou le téléphone compris dans la demande.","Pour une note, mets uniquement le contenu de la note dans content, jamais la phrase d'instruction complète.","Pour les dates relatives comme demain ou vendredi, conserve l'expression dans dateExpression.","Utilise uniquement les actions suivantes:",tools].join("\n");
}
export function buildAgentPlannerRequest({contracts=[],command="",model="acta-planner",nowIso=""}){return {model,messages:[{role:"system",content:buildAgentPlannerSystemPrompt(contracts)},{role:"user",content:[nowIso?`Date/heure de référence: ${nowIso}`:"",`Demande utilisateur: ${String(command||"").trim()}`].filter(Boolean).join("\n")}],response_format:{type:"json_schema",json_schema:buildAgentPlannerSchema(contracts)},temperature:0.1,max_tokens:800,stream:false};}


// ACTA_AGENT_TWO_STAGE_PLANNER_V6
//
// Phase 1 : classifier UNE action autorisée, sans paramètres.
// Phase 2 : figer cette action et extraire tous ses champs.
// Les champs absents sont explicitement null afin d'éviter
// les omissions silencieuses et toute invention du modèle.

function classificationBranch(
  contract
) {
  return {
    type: "object",
    properties: {
      id: {
        type: "string",
        const: contract.id,
      },
      params: {
        type: "object",
        properties: {},
        additionalProperties: false,
      },
    },
    required: [
      "id",
      "params",
    ],
    additionalProperties: false,
  };
}


function nullableFieldSchema(
  def
) {
  return {
    description:
      def.description
      || def.name,
    anyOf: [
      fieldSchema(def),
      {
        type: "null",
      },
    ],
  };
}


function extractionParamsSchema(
  contract
) {
  const properties = {};

  for (
    const def
    of contract.fields || []
  ) {
    properties[def.name] =
      nullableFieldSchema(
        def
      );
  }

  return {
    type: "object",
    properties,
    required:
      (contract.fields || [])
        .map(
          (def) =>
            def.name
        ),
    additionalProperties: false,
  };
}


function extractionBranch(
  contract
) {
  return {
    type: "object",
    properties: {
      id: {
        type: "string",
        const: contract.id,
      },
      params:
        extractionParamsSchema(
          contract
        ),
    },
    required: [
      "id",
      "params",
    ],
    additionalProperties: false,
  };
}


export function buildAgentActionClassificationSchema(
  contracts = []
) {
  const ready =
    contracts.filter(
      (contract) =>
        contract.plannerReady
    );

  if (!ready.length) {
    throw new Error(
      "Aucune action Agent disponible pour la classification."
    );
  }

  return {
    name:
      "acta_agent_action_classification",
    strict: true,
    schema: {
      type: "object",
      properties: {
        actions: {
          type: "array",
          minItems: 1,
          maxItems: 1,
          items: {
            oneOf:
              ready.map(
                classificationBranch
              ),
          },
        },
      },
      required: [
        "actions",
      ],
      additionalProperties: false,
    },
  };
}


export function buildAgentActionExtractionSchema(
  contract
) {
  if (
    !contract
    || !contract.plannerReady
  ) {
    throw new Error(
      "Action Agent invalide pour l'extraction."
    );
  }

  return {
    name:
      `acta_agent_extract_${
        contract.id.replace(
          /[^a-zA-Z0-9_]/g,
          "_"
        )
      }`,
    strict: true,
    schema: {
      type: "object",
      properties: {
        actions: {
          type: "array",
          minItems: 1,
          maxItems: 1,
          items:
            extractionBranch(
              contract
            ),
        },
      },
      required: [
        "actions",
      ],
      additionalProperties: false,
    },
  };
}


export function buildAgentActionClassificationPrompt(
  contracts = []
) {
  const tools =
    contracts
      .filter(
        (contract) =>
          contract.plannerReady
      )
      .map(
        (contract) => {
          const aliases =
            (contract.aliases || [])
              .slice(0, 5)
              .join(", ");

          return [
            `- ${contract.id}: ${contract.label}`,
            aliases
              ? `  exemples: ${aliases}`
              : "",
          ]
            .filter(Boolean)
            .join("\n");
        }
      )
      .join("\n");

  return [
    "Tu es le classifieur d'intention de l'Agent Acta.",
    "Tu choisis UNE SEULE action parmi celles autorisées.",
    "Tu n'extrais aucun paramètre dans cette étape.",
    "Tu n'exécutes jamais l'action métier.",
    "Règles de désambiguïsation :",
    '- "rappelle", "relance", "recontacte" => contact.followup.create si cette action est disponible, jamais meeting.create.',
    '- "crée", "programme" ou "planifie un rendez-vous" => meeting.create.',
    '- "décale", "modifie" ou "replanifie le rendez-vous" => meeting.update.',
    '- "le rendez-vous a été honoré, annulé, reporté ou non honoré" => meeting.outcome.',
    '- "ouvre la machine" ou "fiche machine" => machine.open.',
    '- "ouvre l’intervention", "mon intervention" => intervention.open lorsque l’utilisateur vise une intervention précise.',
    '- "démarre", "commence", "termine", "clôture" ou "confirme" une intervention => intervention.transition.',
    '- "annule l’intervention" => intervention.cancel, jamais intervention.transition.',
    '- "affecte", "assigne" ou "attribue" un technicien => intervention.assign.',
    "Utilise uniquement les actions suivantes :",
    tools,
    "Réponds uniquement selon le JSON Schema fourni.",
    "/no_think",
  ].join("\n");
}


export function buildAgentActionExtractionPrompt(
  contract
) {
  const fields =
    (contract.fields || [])
      .map(
        (def) =>
          `- ${def.name}: ${
            def.description
            || def.name
          }`
      )
      .join("\n");

  return [
    "Tu es l'extracteur de paramètres de l'Agent Acta.",
    `L'action est définitivement fixée à : ${contract.id}.`,
    "Tu n'as pas le droit de changer cette action.",
    "Extrais uniquement les informations explicitement présentes dans la demande utilisateur.",
    "N'invente jamais un identifiant, un contact, une date, une heure, une durée, un montant ou une autre information.",
    "Tous les champs définis par le JSON Schema doivent être présents.",
    "Si une information n'est pas fournie, mets null. N'utilise jamais une chaîne vide à la place de null.",
    "contactQuery contient uniquement l'identité exacte du contact telle qu'elle apparaît dans la demande, sans préfixe name:, name=, contact: ou id:.",
    "dateExpression contient uniquement l'expression de date dans les mots et la langue de l'utilisateur, sans l'heure et sans traduction.",
    "time contient uniquement l'heure au format HH:MM.",
    "durationMinutes contient exactement le nombre de minutes annoncé.",
    "content contient uniquement le contenu de la note, sans l'instruction.",
    'Pour un résultat de rendez-vous : "honoré" => "honored", "reporté" => "rescheduled", "non honoré" ou "absent" => "no_show".',
    'Pour intervention.transition : "confirme" => "confirmed", "démarre" ou "commence" => "in_progress", "termine", "clôture" ou "fini" => "completed".',
    "machineId, interventionId, installationId et technicianId ne doivent jamais être fabriqués à partir d'un nom ou d'une description. Sans identifiant explicitement fourni ou injecté par le contexte Acta, mets null.",
    "Champs de cette action :",
    fields || "- aucun paramètre",
    "Réponds uniquement selon le JSON Schema fourni.",
    "/no_think",
  ].join("\n");
}


export function buildAgentActionClassificationRequest({
  contracts = [],
  command = "",
  model =
    "acta-planner",
  nowIso = "",
}) {
  return {
    model,
    messages: [
      {
        role: "system",
        content:
          buildAgentActionClassificationPrompt(
            contracts
          ),
      },
      {
        role: "user",
        content: [
          nowIso
            ? `Date/heure de référence: ${nowIso}`
            : "",
          `Demande utilisateur: ${
            String(
              command || ""
            ).trim()
          }`,
        ]
          .filter(Boolean)
          .join("\n"),
      },
    ],
    response_format: {
      type: "json_schema",
      json_schema:
        buildAgentActionClassificationSchema(
          contracts
        ),
    },
    temperature: 0,
    max_tokens: 160,
    stream: false,
  };
}


export function buildAgentActionExtractionRequest({
  contract,
  command = "",
  model =
    "acta-planner",
  nowIso = "",
}) {
  return {
    model,
    messages: [
      {
        role: "system",
        content:
          buildAgentActionExtractionPrompt(
            contract
          ),
      },
      {
        role: "user",
        content: [
          nowIso
            ? `Date/heure de référence: ${nowIso}`
            : "",
          `Demande utilisateur: ${
            String(
              command || ""
            ).trim()
          }`,
        ]
          .filter(Boolean)
          .join("\n"),
      },
    ],
    response_format: {
      type: "json_schema",
      json_schema:
        buildAgentActionExtractionSchema(
          contract
        ),
    },
    temperature: 0,
    max_tokens: 500,
    stream: false,
  };
}
